import { render, staticRenderFns } from "./CloudBankAccount.vue?vue&type=template&id=5cbbaeee&"
import script from "./CloudBankAccount.vue?vue&type=script&lang=js&"
export * from "./CloudBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports